import { InfluencerNewProfileHeaderV2, useAllTwitterSimilarInfluencersQuery } from '@anytag/graphql';
import { DEFAULT_SIMILAR_INFLUENCERS_LIMITATION } from '@anytag/shared-constants';
import { useAllAvailableCountryOptions } from '@anytag/shared-hooks';
import { useInfluencerProfileSimilarInfluencersFilter } from '../../hooks';
import { InfluencerSelectedAccountInfo } from '../../types';
import { InfluencerProfileSimilarInfluencers, InfluencerProfileSimilarInfluencersProps } from '../shared';

const DEFAULT_FETCH_LIMITATION = DEFAULT_SIMILAR_INFLUENCERS_LIMITATION.PROFILE.FETCH;

export interface InfluencerTwitterProfileSimilarInfluencersProps {
  className?: string;
  socialAccount: InfluencerSelectedAccountInfo;
  influencerProfile: InfluencerNewProfileHeaderV2;
}

export const InfluencerTwitterProfileSimilarInfluencers = ({
  socialAccount,
  influencerProfile: { country }
}: InfluencerTwitterProfileSimilarInfluencersProps) => {
  const { allAvailableCountryOptions } = useAllAvailableCountryOptions();
  const { data, loading, refetch } = useAllTwitterSimilarInfluencersQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: { genders: [], accountId: socialAccount.id, limit: DEFAULT_FETCH_LIMITATION },
    skip: allAvailableCountryOptions.findIndex((option) => option.label === country.name) === -1
  });
  const { filter, handleFilterChange } = useInfluencerProfileSimilarInfluencersFilter({
    refetch,
    limit: DEFAULT_FETCH_LIMITATION
  });

  const similarInfluencers: InfluencerProfileSimilarInfluencersProps['data'] =
    data?.allTwitterSimilarInfluencers?.map((infl) => ({
      id: infl.id,
      name: infl.name,
      avatar: infl.avatar,
      gender: infl.gender,
      countryName: infl.country.name,
      followers: infl.influencerFollowers,
      socialAccountId: infl.socialAccountId,
      engagementRate: infl.influencerEngagementRate
    })) || [];

  return (
    <InfluencerProfileSimilarInfluencers
      filter={filter}
      loading={loading}
      socialMedia="TWITTER"
      data={similarInfluencers}
      onFilterChange={handleFilterChange}
    />
  );
};
